import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys = 'heading' | 'description' | 'adminLink';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	heading: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.empty-state.heading',
		defaultMessage: 'Bring your favorite apps into Search and Chat',
		description:
			'Heading displayed in the discovery tab empty state when no third-party apps are available',
	},
	description: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.empty-state.description',
		defaultMessage:
			'Get answers from Google Drive, Slack, Salesforce, and more. Your org admin manages app connections.',
		description:
			'Description text in the discovery tab empty state explaining that org admin manages app connections',
	},
	adminLink: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.empty-state.admin-link',
		defaultMessage: 'Ask them to connect your apps',
		description: 'Link text prompting the user to ask their org admin to connect apps',
	},
});
